import {
  getEstateEdit,
  getEstateProperties,
  getTotalEstate,
  updateEstate,
  updateEstateValidate,
  updateEstateSeller,
  deleteEstate,
  getEstateRecommend,
  getEstateDetailForBidder,
  getEstateSellerDetail,
  getEstateSellerExhibitDetail,
  getEstateItemValue,
  createEstate,
  getFavorite,
  likeOrUnlikeEstate,
  getCompaniesTrainLinePrefecture,
  getTrainLineStation,
  getSearchResult,
  saveCondition,
  biddingEstate,
  getSearchWatching,
  getSearchBidding,
  getSearchWonBid,
  getSearchExhibition,
  trackUserSearch,
  checkBidOneTime,
  checkSamePriceBidding,
} from '@/apis/estate';
import {
  DEFAULT_DATE_FORMAT,
  DEFAULT_MONTH_FORMAT,
  DEFAULT_MONTH_FORMAT_JP,
} from '@/constants/common';
import {
  ESTATE_CREATE_STEP_0,
  ESTATE_CREATE_STEP_1,
  ESTATE_CREATE_STEP_2,
  CANCEL_ESTATE,
} from '@/constants/estate';
import {
  BIDDING_LIST_BID,
  BIDDING_LIST_EXHIBITION,
  BIDDING_LIST_WATCH,
  BIDDING_LIST_WON,
} from '@/constants/screen';
import dayjs from '@/plugins/dayjs';
import { ESTATES } from '../mutation-types';

const dataEstateCreateInit = [
  {
    step: ESTATE_CREATE_STEP_0,
    value: false,
  },
  {
    step: ESTATE_CREATE_STEP_1,
    value: {},
  },
  {
    step: ESTATE_CREATE_STEP_2,
    value: {
      post_code: '',
      prefecture: '',
      city: '',
      address1: '',
      address2: '',
      address3: '',
      railroad_company: '',
      train_line1: '',
      station1: '',
      train_line2: '',
      station2: '',
      train_line3: '',
      station3: '',
      transport_method1: '',
      transport_time1: '',
      transport_method2: '',
      transport_time2: '',
      transport_method3: '',
      transport_time3: '',
      address1_show_flag: 1,
      address2_show_flag: 1,
      address3_show_flag: 1,
    },
  },
  {
    step: 3,
    value: {
      estate_name: '',
      price_init: '',
      price_min_bidding: '',
      bidding_type: '',
      end_date: '',
      purpose: '',
      transaction_mode: '',
      remuneration_type: '',
      structure: '',
      total_floor_ground: '',
      total_floor_underground: '',
      floor_position: '',
      building_map: '',
      area_type: '',
      public_area: '',
      own_area: '',
      construct_date: '',
      total_flat: '',
      land_ownership: '',
      management_company: '',
      management_method: '',
      management_fee: '',
      repairment_fund: '',
      cancel_condition: '',
      rental_management_method: '',
      repair_fund_schedule: '',
      situation: '',
      shortest_delivery_date: '',
      move_in_fee: '',
      deposit: '',
      images: [],
      note: [
        {
          note: '',
          is_new: true,
          new_id: 1,
        },
      ],
      document_link: [],
      construct_area: '',
      total_floor_area: '',
      road_width: '',
      type_of_land: '',
      use_of_area: '',
      district: '',
      construction_coverage: '',
      using_area_ratio: '',
      parking_car: '',
      parking_motobike: '',
      parking_bike: '',
      gas_service: '',
      water_service: '',
      eletric_service: '',
      waste_water_service: '',
      distribution_seller: '',
      construction_company: '',
      design_company: '',
      transcipt_show_flag: 1,
    },
  },
];

export const state = {
  estateDetail: {},
  estateSellerDetail: {
    timeEndDate: null,
  },
  estateSellerExhibitDetail: {
    timeEndDate: null,
    estate_bidding: {},
    estate_images: [],
  },
  estateCreate: JSON.parse(JSON.stringify(dataEstateCreateInit)),
  totalEstate: {},
  estateProperties: {},
  validateEstateUpdateRes: {},
  estateRecommend: [],
  estate: {
    timeEndDate: null,
    users_wonbid: null,
    forwarder: [],
    forwarder_advantage: null,
  },
  estateItemValue: {},
  estateFavorite: [],
  createServerErrors: {},
  createEstateSuccess: {},
  updateEstateSellerSuccess: {},
  companiesTrainLine: [],
  trainLineStation: [],
  searchResult: {},
  quickSearchTotal: 0,
  listEstateUser: {},
  errors: {},
  estateExhibitStep1: {},
  status: null,
};

export const getters = {
  status: (state) => state.status,
  estateDetail: (state) => state.estateDetail,
  totalEstate: (state) => state.totalEstate,
  estateProperties: (state) => state.estateProperties,
  estateRecommend: (state) => state.estateRecommend,
  // if (state.estateFavorite) {
  //   state.estateRecommend = state.estateRecommend.map(obj => ({
  //     ...obj,
  //     like: state.estateFavorite.includes(obj.estate_bidding_id)
  //   }));
  // }
  estate: (state) => {
    if (state.estate?.estate_document) {
      state.estate = {
        ...state.estate,
        estate_document: state.estate.estate_document.map((el) => ({
          ...el,
          fileName: el.document_link?.replace(/.*_/, ''),
        })),
      };
    }

    return state.estate;
  },
  estateOrigin: (state) => state.estate,
  estateSellerDetail: (state) => {
    if (state.estateSellerDetail?.estate_document) {
      state.estateSellerDetail = {
        ...state.estateSellerDetail,
        estate_document: state.estateSellerDetail.estate_document.map((el) => ({
          ...el,
          fileName: el.document_link?.replace(/.*_/, ''),
        })),
      };
    }
    return state.estateSellerDetail;
  },
  estateSellerDetailOrigin: (state) => state.estateSellerDetail,
  estateSellerExhibitDetail: (state) => {
    if (state.estateSellerExhibitDetail?.estate_document) {
      state.estateSellerExhibitDetail = {
        ...state.estateSellerExhibitDetail,
        estate_document: state.estateSellerExhibitDetail.estate_document.map((el) => ({
          ...el,
          fileName: el.document_link?.replace(/.*_/, ''),
        })),
      };
    }
    return state.estateSellerExhibitDetail;
  },
  estateItemValue: (state) => state.estateItemValue,
  validateEstateUpdateRes: (state) => state.validateEstateUpdateRes,
  estateCreate: (state) => state.estateCreate,
  estateFavorite: (state) => state.estateFavorite,
  createServerErrors: (state) => state.createServerErrors,
  estateCreateSuccess: (state) => state.createEstateSuccess,
  updateCreateSuccess: (state) => state.updateEstateSellerSuccess,
  companiesTrainLine: (state) => state.companiesTrainLine,
  trainLineStation: (state) => state.trainLineStation,
  searchResult: (state) => state.searchResult,
  quickSearchTotal: (state) => state.quickSearchTotal,
  listEstateUser: (state) => state.listEstateUser,
  getErrors: (state) => state.errors,
  getEstateExhibitStep1: (state) => state.estateExhibitStep1,
};

export const mutations = {
  [ESTATES.UPDATE_STATUS](state, data) {
    state.status = CANCEL_ESTATE;
  },
  [ESTATES.GET_ESTATE](state, data) {
    if (!data.error) {
      state.estate = { ...state.estate, ...data };
      state.estate.construct_date = dayjs(data.construct_date, DEFAULT_MONTH_FORMAT).format(
        DEFAULT_MONTH_FORMAT
      );
      state.estate.shortest_delivery_date = dayjs(
        data.shortest_delivery_date,
        DEFAULT_DATE_FORMAT
      ).format(DEFAULT_DATE_FORMAT);
      state.estate.timeEndDate = data.end_date;
      if (state.estate.wonBidStatus) {
        state.estate.biddingStatus = 3;
      }
    }
  },
  [ESTATES.GET_ESTATE_SELLER](state, data) {
    if (!data.error) {
      state.estateSellerDetail = data;
      state.estateSellerDetail.construct_date = dayjs(
        data.construct_date,
        DEFAULT_MONTH_FORMAT
      ).format(DEFAULT_MONTH_FORMAT);
      state.estateSellerDetail.shortest_delivery_date = dayjs(
        data.shortest_delivery_date,
        DEFAULT_DATE_FORMAT
      ).format(DEFAULT_DATE_FORMAT);
      state.estateSellerDetail.timeEndDate = data.end_date;
    }
  },
  [ESTATES.GET_ESTATE_EXHIBIT_SELLER](state, data) {
    if (!data.error) {
      state.estateSellerExhibitDetail = data;
      if (state.estateSellerExhibitDetail.construct_date) {
        state.estateSellerExhibitDetail.construct_date = dayjs(
          data.construct_date,
          DEFAULT_MONTH_FORMAT
        ).format(DEFAULT_MONTH_FORMAT);
      }
      if (state.estateSellerExhibitDetail.shortest_delivery_date) {
        state.estateSellerExhibitDetail.shortest_delivery_date = dayjs(
          data.shortest_delivery_date,
          DEFAULT_DATE_FORMAT
        ).format(DEFAULT_DATE_FORMAT);
      }
      state.estateSellerExhibitDetail.timeEndDate = data.end_date;
      if (state.estateSellerExhibitDetail.railroad_company) {
        state.estateSellerExhibitDetail.railroad_company = {
          value: data.railroad_company?.code,
          label: data.railroad_company?.value,
        };
      }
      if (state.estateSellerExhibitDetail.train_line1) {
        state.estateSellerExhibitDetail.train_line1 = {
          value: data.train_line1?.code,
          label: data.train_line1?.value,
        };
      }
      if (state.estateSellerExhibitDetail.train_line2) {
        state.estateSellerExhibitDetail.train_line2 = {
          value: data.train_line2?.code,
          label: data.train_line2?.value,
        };
      }
      if (state.estateSellerExhibitDetail.train_line3) {
        state.estateSellerExhibitDetail.train_line3 = {
          value: data.train_line3?.code,
          label: data.train_line3?.value,
        };
      }
      if (state.estateSellerExhibitDetail.station1) {
        state.estateSellerExhibitDetail.station1 = {
          value: data.station1?.code,
          label: data.station1?.value,
        };
      }
      if (state.estateSellerExhibitDetail.station2) {
        state.estateSellerExhibitDetail.station2 = {
          value: data.station2?.code,
          label: data.station2?.value,
        };
      }
      if (state.estateSellerExhibitDetail.station3) {
        state.estateSellerExhibitDetail.station3 = {
          value: data.station3?.code,
          label: data.station3?.value,
        };
      }
      // eslint-disable-next-line
      state.estateSellerExhibitDetail.new_images = [];
      // eslint-disable-next-line
      state.estateSellerExhibitDetail.current_images =
        state.estateSellerExhibitDetail.estate_images.map((item, index) => ({
          ...item,
          position: index + 1,
        }));
      // eslint-disable-next-line
      state.estateSellerExhibitDetail.estate_images_old =
        // state.estateSellerExhibitDetail.new_images = [];
        // // eslint-disable-next-line
        // state.estateSellerExhibitDetail.current_images =
        state.estateSellerExhibitDetail.estate_images.map((item, index) => ({
          ...item,
          position: index + 1,
        }));
      // eslint-disable-next-line
      state.estateSellerExhibitDetail.estate_images =
        state.estateSellerExhibitDetail.estate_images.map((item, index) => ({
          ...item,
          position: index + 1,
        }));
      // eslint-disable-next-line
      state.estateSellerExhibitDetail.estate_document =
        state.estateSellerExhibitDetail.estate_document.map((item, index) => ({
          ...item,
          position: index + 1,
        }));
      // eslint-disable-next-line
      state.estateSellerExhibitDetail.new_pdfs = [];
      // eslint-disable-next-line consistent-return,array-callback-return
      const a = state.estateSellerExhibitDetail.estate_document.filter(
        (item, index) => item.document_type === 1
      );
      state.estateSellerExhibitDetail.current_pdfs = a.map((item, index) => ({
        ...item,
      }));
      // state.estateSellerExhibitDetail.current_pdfs = state.estateSellerExhibitDetail.current_pdfs.filter(item => item !== undefined);
      // eslint-disable-next-line
      state.estateSellerExhibitDetail.new_report_pdfs = [];
      // eslint-disable-next-line
      state.estateSellerExhibitDetail.current_report_pdfs =
        state.estateSellerExhibitDetail.estate_document
          .filter((item) => item.document_type === 2)
          .map((item, index) => ({
            ...item,
          }));
      // eslint-disable-next-line
      state.estateSellerExhibitDetail.current_report_pdfs =
        state.estateSellerExhibitDetail.current_report_pdfs.filter((item) => item !== undefined);
      // eslint-disable-next-line
      state.estateSellerExhibitDetail.estate_document_old =
        state.estateSellerExhibitDetail.estate_document.map((item, index) => ({
          ...item,
        }));
      // eslint-disable-next-line
      state.estateSellerExhibitDetail.estate_notes =
        state.estateSellerExhibitDetail.estate_notes.map((item, index) => ({
          ...item,
          new_id: index + 1,
        }));
      if (state.estateSellerExhibitDetail.transport_time1) {
        state.estateSellerExhibitDetail.transport_time1 = String(
          state.estateSellerExhibitDetail.transport_time1
        );
      }
      if (state.estateSellerExhibitDetail.transport_time2) {
        state.estateSellerExhibitDetail.transport_time2 = String(
          state.estateSellerExhibitDetail.transport_time2
        );
      }
      if (state.estateSellerExhibitDetail.transport_time3) {
        state.estateSellerExhibitDetail.transport_time3 = String(
          state.estateSellerExhibitDetail.transport_time3
        );
      }
      if (state.estateSellerExhibitDetail.estate_bidding.immediate_decision_price) {
        // eslint-disable-next-line
        state.estateSellerExhibitDetail.immediate_decision_price =
          state.estateSellerExhibitDetail.estate_bidding.immediate_decision_price;
      }
      if (state.estateSellerExhibitDetail.estate_bidding.start_price) {
        // eslint-disable-next-line
        state.estateSellerExhibitDetail.start_price =
          state.estateSellerExhibitDetail.estate_bidding.start_price;
      }
      if (state.estateSellerExhibitDetail.estate_bidding.bidding_type) {
        // eslint-disable-next-line
        state.estateSellerExhibitDetail.bidding_type =
          state.estateSellerExhibitDetail.estate_bidding.bidding_type;
      }
      if (state.estateSellerExhibitDetail.estate_bidding.end_date) {
        // eslint-disable-next-line
        state.estateSellerExhibitDetail.end_date =
          state.estateSellerExhibitDetail.estate_bidding.end_date;
      }
    }
  },
  [ESTATES.GET_ESTATE_RECOMMEND](state, data) {
    if (!data.error) {
      state.estateRecommend = data.map((el) => ({
        ...el,
        construct_date: el.construct_date
          ? dayjs(el.construct_date, DEFAULT_MONTH_FORMAT).format(DEFAULT_MONTH_FORMAT_JP)
          : '',
      }));
    }
  },
  [ESTATES.GET_FAVORITE](state, data) {
    if (!data.error) {
      state.estateFavorite = data.map((item) => item.estate_bidding_id);
    }
  },
  [ESTATES.UPDATE_FAVORITE](state, biddingId) {
    const indexId = state.estateFavorite.indexOf(biddingId);
    if (indexId > -1) {
      state.estateFavorite.splice(indexId, 1);
    } else {
      state.estateFavorite.push(biddingId);
    }
  },
  [ESTATES.GET_ESTATE_ITEM_VALUE](state, data) {
    if (!data.error) {
      state.estateItemValue = data;
    }
  },
  [ESTATES.GET_ESTATE_EDIT_DETAIL](state, data) {
    if (!data.error) {
      state.estateDetail = data;
    }
  },
  [ESTATES.GET_ESTATE_TOTAL](state, data) {
    if (!data.error) {
      state.totalEstate = data;
    }
  },
  [ESTATES.GET_ESTATE_PROPERTIES](state, data) {
    if (!data.error) {
      state.estateProperties = data;
    }
  },
  [ESTATES.VALIDATE_ESTATE_UPDATE_RES](state, data) {
    state.validateEstateUpdateRes = data;
  },
  [ESTATES.SAVE_ESTATE_CREATE](state, data) {
    const index = data.step;
    state.estateCreate[index].value = data.value;
  },
  [ESTATES.RESET_ESTATE_CRETATE](state) {
    state.estateCreate = JSON.parse(JSON.stringify(dataEstateCreateInit));
  },
  [ESTATES.CREATE_SERVER_ERROR](state, errors) {
    const firstError = {};
    Object.keys(errors).forEach((value) => {
      [firstError[value]] = errors[value];
    });
    state.errors = firstError;

    state.createServerErrors = firstError;
  },
  [ESTATES.CREATE_SERVER_SUCCESS](state, data) {
    state.createEstateSuccess = data;
  },
  [ESTATES.SET_COMPANIES_TRAIN_LINE](state, data) {
    if (!data.error) {
      state.companiesTrainLine = data.data;
    }
  },
  [ESTATES.SET_TRAIN_LINE_STATION](state, data) {
    if (!data.error) {
      state.trainLineStation = data.data;
    }
  },
  [ESTATES.SET_SEARCH_RESULT](state, data) {
    if (!data?.error) {
      state.searchResult = data;
    }
  },
  [ESTATES.SET_QUICK_SEARCH_TOTAL](state, data) {
    state.quickSearchTotal = data;
  },
  [ESTATES.LIST_ESTATE_USER](state, data) {
    if (!data?.error) {
      state.listEstateUser = data;
    }
  },
  [ESTATES.SAVE_ESTATE_EXHIBIT_STEP_1](state, data) {
    if (!data?.error) {
      state.estateExhibitStep1 = data;
    }
  },
  [ESTATES.UPDATE_ESTATE_SELLER](state, data) {
    state.updateEstateSellerSuccess = data;
  },
};

export const actions = {
  async getEstateEdit({ commit }, id) {
    const res = await getEstateEdit(id);
    commit(ESTATES.GET_ESTATE_EDIT_DETAIL, res);
  },
  async getTotalEstate({ commit }, params) {
    const res = await getTotalEstate(params);
    commit(ESTATES.GET_ESTATE_TOTAL, res);
  },
  async getEstateProperties({ commit }) {
    const res = await getEstateProperties();
    commit(ESTATES.GET_ESTATE_PROPERTIES, res);
  },
  async updateEstateValidate({ commit }, dataValidate) {
    const res = await updateEstateValidate(dataValidate.id, dataValidate.formData);
    commit(ESTATES.VALIDATE_ESTATE_UPDATE_RES, res);
    if (!res.error) {
      commit(ESTATES.GET_ESTATE_EDIT_DETAIL, dataValidate.listData);
    }
  },
  async updateEstate({ commit }, dataValidate) {
    const res = await updateEstate(dataValidate.id, dataValidate.formData);
    commit(ESTATES.VALIDATE_ESTATE_UPDATE_RES, res);
  },
  async saveEstateCreateForm({ commit }, dataEstateCreate) {
    commit(ESTATES.SAVE_ESTATE_CREATE, dataEstateCreate);
  },
  async resetEstateCreate({ commit }) {
    commit(ESTATES.RESET_ESTATE_CRETATE);
  },
  async deleteEstate({ commit }, id) {
    const res = await deleteEstate(id);
    if (res.error) {
      return {
        success: false,
        error: res.error,
      };
    }
    commit(ESTATES.UPDATE_STATUS);
    return {
      success: true,
    };
  },
  async getEstateRecommend({ commit }, params) {
    const res = await getEstateRecommend(params);
    commit(ESTATES.GET_ESTATE_RECOMMEND, res);
  },
  async getEstateDetail({ commit }, id) {
    const res = await getEstateDetailForBidder(id);
    commit(ESTATES.GET_ESTATE, res);
    return new Promise((resolve, reject) => {
      if (res.error) {
        reject(res);
      } else {
        resolve(res);
      }
    });
  },
  async getEstateSellerDetail({ commit }, id) {
    const res = await getEstateSellerDetail(id);
    commit(ESTATES.GET_ESTATE_SELLER, res);
    return new Promise((resolve, reject) => {
      if (res.error) {
        reject(res);
      } else {
        resolve(res);
      }
    });
  },
  async getEstateSellerExhibitDetail({ commit }, id) {
    const res = await getEstateSellerExhibitDetail(id);
    commit(ESTATES.GET_ESTATE_EXHIBIT_SELLER, res);
    return new Promise((resolve, reject) => {
      if (res.error) {
        reject(res);
      } else {
        resolve(res);
      }
    });
  },
  async getEstateItemValue({ commit }, id) {
    const res = await getEstateItemValue(id);
    commit(ESTATES.GET_ESTATE_ITEM_VALUE, res);
  },
  async createEstate({ commit }, payload) {
    const res = await createEstate(payload);
    if (res.error) {
      commit(ESTATES.CREATE_SERVER_ERROR, res?.error?.response?.data?.errors);

      return {
        error: true,
        messages: res?.error?.response?.data?.errors,
      };
    }
    commit(ESTATES.CREATE_SERVER_SUCCESS, res);

    return { error: false };
  },
  async updateEstateSeller({ commit }, payload) {
    const res = await updateEstateSeller(payload.id, payload.data);
    if (res.error) {
      commit(ESTATES.CREATE_SERVER_ERROR, res?.error?.response?.data?.errors);

      return {
        error: true,
        messages: res?.error?.response?.data?.errors,
      };
    }
    commit(ESTATES.UPDATE_ESTATE_SELLER, res);

    return { error: false, estate_id: res?.id };
  },
  async getFavorite({ commit }) {
    const res = await getFavorite();
    commit(ESTATES.GET_FAVORITE, res);
  },
  async likeOrUnlikeEstate({ commit }, params) {
    const res = await likeOrUnlikeEstate(params);
    if (res.error) {
      return true;
    }
    commit(ESTATES.UPDATE_FAVORITE, params.estate_bidding_id);
    return { error: false };
  },

  async getCompanies({ commit }, prefectureCode) {
    const res = await getCompaniesTrainLinePrefecture(prefectureCode);
    commit(ESTATES.SET_COMPANIES_TRAIN_LINE, res);
  },

  async getTrainLineStation({ commit }, params) {
    const res = await getTrainLineStation(params);
    commit(ESTATES.SET_TRAIN_LINE_STATION, res);
  },

  getFormViolationReport({ commit }, params) {
    commit(ESTATES.GET_FORM_VIOLATION_REPORT, params);
  },

  async saveSearchCondition(_, payload) {
    const res = await saveCondition(payload);
    return res;
  },

  async getSearchResult({ commit }, params) {
    const res = await getSearchResult(params);
    commit(ESTATES.SET_SEARCH_RESULT, res.data);
    commit(ESTATES.SET_QUICK_SEARCH_TOTAL, res.data?.total ?? 0);
  },

  async quickSearchResult({ commit }, params) {
    const res = await getSearchResult(params);
    commit(ESTATES.SET_QUICK_SEARCH_TOTAL, res.data?.total);
  },

  submitBiddingEstate(_, params) {
    return new Promise((resolve, reject) => {
      biddingEstate(params)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },

  trackSearch(_, params) {
    return new Promise((resolve, reject) => {
      trackUserSearch(params)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },

  async getListEstateUser({ commit }, params) {
    let res;
    switch (params.from) {
      case BIDDING_LIST_WATCH:
        res = await getSearchWatching(params);
        break;
      case BIDDING_LIST_BID:
        res = await getSearchBidding(params);
        break;
      case BIDDING_LIST_WON:
        res = await getSearchWonBid(params);
        break;
      case BIDDING_LIST_EXHIBITION:
        res = await getSearchExhibition(params);
        break;

      default:
        res = await getSearchWatching(params);
        break;
    }

    commit(ESTATES.LIST_ESTATE_USER, res.data);
  },

  async checkBidOneTime(_, params) {
    return new Promise((resolve, reject) => {
      checkBidOneTime(params)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },

  async checkSamePrice(_, params) {
    return new Promise((resolve, reject) => {
      checkSamePriceBidding(params)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
};
